import { ContactType } from '@api/generated/graphql';

const strings = {
  labels: {
    [ContactType.Phone]: 'Phone',
    [ContactType.MobilePhone]: 'Mobile',
    [ContactType.Email]: 'Email',
    [ContactType.Fax]: 'Fax',
    [ContactType.Unknown]: 'Unknown',
    phoneToggle: 'Toggle Phone Type',
    memo: 'Memo',
    addContactMethod: 'Add Contact Method',
    removeContactMethod: 'Remove Contact Method',
    notifications: 'Notifications',
    jobNotifications: 'Job Notifications',
    invoiceNotifications: 'Invoice Notifications',
    marketingNotifications: 'Marketing Notifications',
    changeContactMethodType: 'Change Contact Method Type',
  },
  placeholders: {
    [ContactType.Phone]: '000-000-0000',
    [ContactType.MobilePhone]: '000-000-0000',
    [ContactType.Email]: 'Add a email',
    [ContactType.Fax]: '000-000-0000',
    [ContactType.Unknown]:
      'This placeholder should never be shown, it is just here to satisfy TypeScript',
    memo: 'Add a memo',
  },
  errors: {
    [ContactType.Email]: 'Enter a valid email address',
    [ContactType.Phone]: 'Enter a valid phone number',
  },
} as const;

export default strings;
